import { useQuery } from '@base-app/web2'
import { APP_QUERY } from '../graphql/applications/queries'

// The application with what the API computed for the signed-in user (cache-first: the sidebar,
// the route guard and the pages share one entry). `loading` is true until the first answer.
export function useViewerApp(appId: string | undefined) {
  const { data, previousData, loading, error, refetch } = useQuery(APP_QUERY, {
    variables: { id: appId ?? '' },
    skip: !appId,
  })
  const fresh = data?.application ?? null
  // A failed refresh reports no data. Keep the last answer for THIS application (Apollo's
  // previousData, never lent to another app), so an authorized user is not sent away because the
  // network blinked. Fails closed with no answer at all, and a revoked app (the API answered
  // `application: null`) is not resurrected: previousData is then that null answer.
  const lastAnswer = previousData?.application ?? null
  const kept = appId && error && !data && lastAnswer?.id === appId ? lastAnswer : null
  const app = fresh ?? kept
  return { app, loading: !!appId && loading && !app, refetch }
}
